import * as React from 'react'
import { IconBase } from './IconBase'
import { IconBaseProps, IconProps } from '../../..'
import { IconButton } from './IconButton'

export const Icon: React.FC<IconProps & IconBaseProps> = props => {
  const { button = false, src, alt, ...rest } = props
  return button ? <IconButton {...props} /> : <IconBase src={src} alt={alt} {...rest} />
}
